export const UPDATE_DEVICE_CONFIG_CONTAINERS = {
    storeAndHardware: 'storeAndHardware',
    numbersAndDates: 'numbersAndDates',
    flags: 'flags',
}

export const CONFIG_STORE_AND_HARDWARE_FIELDS = [
    {name: 'market_name', label: 'Market name'},
    {name: 'cash_desc_number', label: 'Cash desc number'},
    {name: 'mac_address', label: 'MAC address'},
    {name: 'printer_model', label: 'Printer model'},
    {name: 'printer_name', label: 'Printer name'},
    {name: 'printer_number', label: 'Printer number'},
    {name: 'ip_address', label: 'IP address'},
    {name: 'xumo_address', label: 'Xumo address'},
    {name: 'dns', label: 'DNS'},
    {name: 'case', label: 'Case'},
    {name: 'gateway', label: 'Gateway'},
    {name: 'factory_id', label: 'Factory ID'},
    {name: 'payment_connector_ip', label: 'Payment connector IP'},
    {name: 'server_token', label: 'Server token', secure: true},
    {name: 'eth_ip', label: 'Ethernet IP'},
    {name: 'wi_fi_ip', label: 'Wi-Fi IP'},
    {name: 'additional_text', label: 'Additional text', wide: true},
]

export const CONFIG_NUMBER_FIELDS = [
    {name: 'lat', label: 'Latitude', precision: 6, min: -90, max: 90},
    {name: 'long', label: 'Longitude', precision: 6, min: -180, max: 180},
    {name: 'printer_type', label: 'Printer type', precision: 0},
    {name: 'line_char_count', label: 'Line char count', precision: 0},
    {name: 'space_after_print', label: 'Space after print', precision: 0},
    {name: 'mxik_timeout', label: 'MXIK timeout', precision: 0},
    {name: 'left_z_reports_validate', label: 'Left Z reports validate', precision: 0},
]

export const CONFIG_DATE_FIELDS = [
    {name: 'location_updated_date', label: 'Location updated date'},
    {name: 'ofd_registration_date', label: 'OFD registration date'},
]

export const CONFIG_FLAG_FIELDS = [
    {name: 'special_version', label: 'Special version'},
    {name: 'reader', label: 'Reader'},
    {name: 'local_labels_disabled', label: 'Local labels disabled'},
    {name: 'save_orders', label: 'Save orders'},
    {name: 'check_time', label: 'Check time'},
    {name: 'local_mxik_disable', label: 'Local MXIK disable'},
    {name: 'auto_cut_banner', label: 'Auto cut banner'},
    {name: 'new_api_enabled', label: 'New API enabled'},
    {name: 'over_cash_not_permitted', label: 'Over cash not permitted'},
    {name: 'okm_validation', label: 'OKM validation'},
    {name: 'mark_version', label: 'Mark version'},
    {name: 'qr_icon_center', label: 'QR icon center'},
    {name: 'save_order', label: 'Save order'},
]

export const UPDATE_DEVICE_CONFIG_CONTAINER_FIELDS = {
    [UPDATE_DEVICE_CONFIG_CONTAINERS.storeAndHardware]:
        CONFIG_STORE_AND_HARDWARE_FIELDS.map(field => field.name),
    [UPDATE_DEVICE_CONFIG_CONTAINERS.numbersAndDates]: [
        ...CONFIG_NUMBER_FIELDS,
        ...CONFIG_DATE_FIELDS,
    ].map(field => field.name),
    [UPDATE_DEVICE_CONFIG_CONTAINERS.flags]: CONFIG_FLAG_FIELDS.map(
        field => field.name,
    ),
}
